import { gql } from '@apollo/client';

export default gql`
  query userProfile {
    plans {
      plans {
        id
        name
        price
        billingInterval
        billingIntervalType
        placesLimit
        inspectionSubjectsLimit
        inspectionsLimit
        canSet
      }
    }
    user {
      email
      name
      surname
      sendPushNotificationsSetting
      sendEmailNotificationsSetting
      otpEnabled
      storageProviders {
        id
        providerType
        active
        tokenExpired
        expiresAt
      }
      activeStorageProvider {
        id
        providerType
        active
        tokenExpired
        expiresAt
      }
    }
  }
`;
